import React, { forwardRef } from 'react'
import { REACT_APP_CHILD_URL } from '../../services/constant'
import styles from "./Modal.module.scss";

const Modal = forwardRef((props,ref) => {
  return (
    <div  className={styles.overlayStyles}>
    <div className={styles.overlayStyles__modal}>
      <iframe
        ref={ref}
        id="react-app-iframe"
        className='iframe-modal-active'
        src={REACT_APP_CHILD_URL}
        title="React App Iframe"
      ></iframe>
    </div>
  </div>
  )
})

export default Modal